export default (block) => {
  const mappedBlock = {
    ...block.company.content,
    logo: block.company.content.logo.filename
  }
  return mappedBlock
}
